<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-flex tw-gap-2">
      <i-form-item
        :label="$t('dashboard.filters.date_range')"
        prop="role"
      >
        <el-select
          :model-value="metricDateRange"
          placeholder=""
          @change="(payload) => metricDateRange = payload"
        >
          <el-option
            :label="$t('dashboard.filters.days_count', { count: 30 })"
            value="last_30_days"
          />
          <el-option
            :label="$t('dashboard.filters.days_count', { count: 90 })"
            value="last_90_days"
          />
          <el-option
            :label="$t('dashboard.filters.days_count', { count: 180 })"
            value="last_180_days"
          />
          <el-option
            :label="$t('dashboard.filters.days_count_custom')"
            value="custom"
          />
        </el-select>
      </i-form-item>
      <el-form-item
        :label="$t('common.fields.company')"
        :class="filters.company_id ? 'has-value' : ''"
        prop="profile.client_company_id"
      >
        <el-select
          :model-value="filters.company_id"
          placeholder=""
          filterable
          clearable
          :filter-method="clientCompaniesFilterMethod"
          @visible-change="handleClientCompaniesVisibleChange"
          @change="payload => updateFilter('company_id', payload)"
        >
          <el-option
            v-for="item in filteredClientCompanies"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </div>
    <div
      v-if="metricDateRange === 'custom'"
      class="tw-flex tw-gap-2 tw-mb-2"
    >
      <el-form-item
        :label="$t('common.fields.date_from')"
        prop="issue_date"
      >
        <el-date-picker
          v-model="filters.date_from"
          type="date"
          :placeholder="$t('common.fields.select_date')"
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY"
          @change="(payload) => updateFilter('date_from', payload)"
        />
      </el-form-item>
      <el-form-item
        :label="$t('common.fields.date_to')"
        prop="issue_date"
      >
        <el-date-picker
          v-model="filters.date_to"
          type="date"
          :placeholder="$t('common.fields.select_date')"
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY"
          @change="(payload) => updateFilter('date_to', payload)"
        />
      </el-form-item>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { clientCompanyFilterMixin } from '@/mixins/clientCompanyFilterMixin';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'MetricFilters',
  mixins: [clientCompanyFilterMixin],
  props: {
    filtersStateRelativePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      metricDateRange: 'last_30_days',
    };
  },
  computed: {
    filters() {
      return this.$store.state.v2.admin.dashboard[this.filtersStateRelativePath];
    },
    ...mapGetters({
      internalUsersAreEmpty: 'v2/admin/cms/internal/users/selectOptionsAreEmpty',
      clientCompanies: 'v2/admin/cms/clients/companies/selectOptions',
    }),
  },
  watch: {
    metricDateRange(newValue) {
      if (newValue !== 'custom') {
        const dateTo = dayjs().format('DD.MM.YYYY');
        const dateFrom = dayjs().subtract(parseInt(newValue.split('_')[1]), 'day').format('DD.MM.YYYY');
        this.updateFilter('date_from', dateFrom);
        this.updateFilter('date_to', dateTo);
      }
    },
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/dashboard/updateFilter', { metricType: this.filtersStateRelativePath, field, payload });
    },
  },
});
</script>
